<template>
  <div class="search-customer-container">
    <div class="search-customer-input-group row">
      <InputField
        class="input-field-group abn-field-group"
        v-model="customerSearch"
        :label="isNZ ? 'Add your business NZBN or company name ' : 'Add your business ABN or company name'"
        :placeholder="handleLabel(customerSearch, isNZ ? 'Add NZBN or company name' : 'Add ABN or company name')"
        :minLength="2"
        :disable="isParentComponentLoading"
        :required="true"
        :hasRequiredLabel="false"
      />
      <div class="search-customer-input-action">
        <CalculatorButton
          color="secondary"
          rounded
          label="Search"
          hasChevronIcon
          @click="handleSearchCustomer"
          :loading="isSearchingCustomer"
          :disabled="isParentComponentLoading && isSearchingCustomer"
        />
      </div>
    </div>
    <div v-if="showResults && !isSearchingCustomer" class="search-customer-results column q-col-gutter-sm">
      <p class="font-nunito text-grey-9" v-if="customerSearch && results.length <= 0">No results found.</p>
      <div v-else>
        <QSeparator class="q-my-lg" />
        <p class="text-secondary text-weight-bold" style="font-size: 18px">Your business</p>
        <QItem class="customer-result-item row" v-for="(customer, index) in formattedResults" :key="index">
          <div class="input-field-group col-6">
            <label class="field-label">Company name</label>
            <QRadio v-model="selected" :val="customer" :label="customer.name" />
          </div>
          <div :class="isNZ ? 'col-6' : 'col-3'">
            <InputField class="input-field-group" v-model="customer.abn" :label="isNZ ? 'NZBN' : 'ABN'" readonly />
          </div>
          <div v-if="!isNZ" class="col-3">
            <InputField class="input-field-group" v-model="customer.location" label="Location" readonly />
          </div>
        </QItem>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { QRadio, QItem, QSeparator } from 'quasar';
import InputField from '@/components/Atoms/InputField';
import CalculatorButton from '@/components/Calculator/CalculatorButton';
import { businessLookupMixin } from '@/mixins';

export default {
  name: 'SearchCustomer',
  mixins: [businessLookupMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customerSearch: '',
      isParentComponentLoading: this.loading,
      isSearchingCustomer: false,
      showResults: false,
      results: [],
      selected: {}
    };
  },
  computed: {
    ...mapGetters({
      isNZ: 'theme/isNZ'
    }),
    formattedResults() {
      if (this.results.length) {
        return this.results.slice(0, 6);
      }

      return this.results;
    }
  },
  methods: {
    handleLabel(value, label) {
      if (!value) return label;
    },
    handleSelectCustomer() {},
    async handleSearchCustomer() {
      try {
        this.isSearchingCustomer = true;
        const response = await this.searchCompanies({ param: this.customerSearch, region: this.isNZ ? 'NZ' : 'AU' });

        this.results = response?.rows?.map((customer) => ({ ...customer, location: `${customer.postCode} ${customer.stateCode}` })) || [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(JSON.stringify({ error }));

        this.results = [];
      } finally {
        this.isSearchingCustomer = false;
        setTimeout(() => {
          this.showResults = true;
        }, 200);
      }
    }
  },
  watch: {
    selected(value) {
      this.customerSearch = value.name;
      this.showResults = false;
      this.$emit('input', value);
    }
  },
  components: {
    InputField,
    CalculatorButton,
    QRadio,
    QItem,
    QSeparator
  }
};
</script>

<style lang="sass">
.search-customer-container
  display: flex
  flex-flow: column wrap
  width: 100%

  .search-customer-input-group
    width: 100%
    align-items: start
    justify-content: space-between

    .search-customer-input-action
      width: 200px
      margin-top: 27px
      .q-btn.calculator-button
        width: 100%

  .input-field-group
    .field-label
      color: var(--primary-color)
      font-size: 16px
      font-weight: 700

    &.abn-field-group
      max-width: calc(100% - 210px)
      width: 100%
      padding: 0
  .search-customer-results
    width: 100%
    .customer-result-item
      width: 100%
  @media (max-width: 599px)
    .input-field-group.abn-field-group
      max-width: 100%

    .search-customer-input-group .search-customer-input-action
      width: 100%
      margin-top: 10px
</style>
